(function () {
  var SECTION_ID = 'cart-drawer'; // Dawn's drawer section
  var DRAWER_SEL = '#CartDrawer'; // container Dawn re-renders
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function same(a, b) { return a.trim().toLowerCase() === b.trim().toLowerCase(); }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }); }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // The discount param REPLACES all codes, so always send the full list.
  function setCodes(codes) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ discount: codes.join(','), sections: SECTION_ID })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

 function msg(text, isError) {
  var el = document.querySelector('[data-ox-msg]');
  if (!el) return;
  el.textContent = text || '';
  el.hidden = !text;                          // ← add this
  el.classList.toggle('is-error', !!isError);
}

  function repaint(cart) {
    var html = cart.sections && cart.sections[SECTION_ID];
    if (html) {
      var next = new DOMParser().parseFromString(html, 'text/html').querySelector(DRAWER_SEL);
      var current = document.querySelector(DRAWER_SEL);
      if (next && current) current.innerHTML = next.innerHTML;
    }
    renderCodes(cart);
  }

  function renderCodes(cart) {
    var list = document.querySelector('[data-ox-codes]');
    if (!list) return;
    list.textContent = '';
    (cart.discount_codes || []).forEach(function (d) {
      if (!d.applicable) return;
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.oxRemove = d.code;
      btn.setAttribute('aria-label', 'Remove code ' + d.code);
      btn.textContent = '×';
      li.append(d.code + ' ', btn);
      list.appendChild(li);
    });
  }

  function apply(code) {
  code = (code || '').trim();
  if (!code) { msg('Enter a code first.', true); return Promise.resolve(); }
  msg('Checking…');
  return getCart()
    .then(function (cart) {
      var codes = codesOf(cart).filter(function (c) { return !same(c, code); });
      return setCodes(codes.concat(code));
    })
    .then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return same(d.code, code); })[0];
      if (hit && hit.applicable) {
        repaint(cart);
        msg(code.toUpperCase() + ' applied.');
        return;
      }
      // Not applicable: strip it back off, but DON'T repaint — that would wipe the message.
      var keep = codesOf(cart).filter(function (c) { return !same(c, code); });
      return setCodes(keep).then(function () {
        renderCodes(cart);                    // refresh chips only, leaves the panel + message intact
        msg('Enter a valid discount code', true);
      });
    })
    .catch(function () { msg('Something went wrong. Please try again.', true); });
}

  function remove(code) {
    return getCart()
      .then(function (cart) {
        return setCodes(codesOf(cart).filter(function (c) { return !same(c, code); }));
      })
      .then(repaint)
      .catch(function () { msg('Could not remove that code.', true); });
  }

  function openPanel() {
    var panel = document.getElementById('ox-discount-panel');
    var toggle = document.querySelector('[data-ox-toggle]');
    if (!panel || !toggle) return;
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ox-apply]')) {
      apply(document.getElementById('ox-discount-input').value);
    } else if (t.closest('[data-ox-remove]')) {
      remove(t.closest('[data-ox-remove]').dataset.oxRemove);
    } else if (t.closest('[data-ox-toggle]')) {
      var toggle = t.closest('[data-ox-toggle]');
      var panel = document.getElementById('ox-discount-panel');
      var opening = panel.hidden;
      panel.hidden = !opening;
      toggle.setAttribute('aria-expanded', String(opening));
      if (opening) panel.querySelector('input').focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.id === 'ox-discount-input') {
      e.preventDefault();
      apply(e.target.value);
    }
  });

  // Show codes already on the cart (including ones added by /discount/CODE links).
  document.addEventListener('DOMContentLoaded', function () {
    getCart().then(renderCodes).catch(function () {});
  });

  // Dawn redraws the drawer after add/change, which wipes the list. Fill it again.
  // subscribe() lives in Dawn's pubsub.js; PUB_SUB_EVENTS in constants.js ('cart-update').
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      return getCart().then(renderCodes).catch(function () {});
    });
  }
})();